module.exports = __webpack_public_path__ + "img/shangxianhou.92984eff.png";